import { css } from 'styled-components';
import { SpacingName } from '../../theme/constants';
import { TypographyName } from '../../theme/typography';
import { getTypography, getSpacing, rgba } from '../../theme/utils';
export const item = _ref => {
  let {
    theme
  } = _ref;
  return css(["", " & :last-of-type{", ";};"], getSpacing.marginBottom(theme, SpacingName.SMALL), getSpacing.marginBottom(theme, 0));
};
export const itemTitleWrapper = _ref2 => {
  let {
    theme,
    isSkeleton
  } = _ref2;
  return css(["", " align-items:center;background:", ";border-radius:6px;color:", ";cursor:pointer;display:flex;justify-content:space-between;position:relative;", " ", ""], getSpacing.padding(theme, SpacingName.SMALL), theme.palettes.neutrals.lightest, theme.palettes.neutrals.darkest, !isSkeleton && `
      box-shadow: 0 2px 4px 0 ${rgba(theme.palettes.neutrals.darkest, 0.2)};
    `, isSkeleton && `
      border: 1px solid ${theme.palettes.neutrals.lighter};
    `);
};
export const itemTitle = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["", " ", " flex:1;"], getTypography(theme, TypographyName.BODY), getSpacing.marginRight(theme, SpacingName.MEDIUM));
};
export const itemTitleIcon = _ref4 => {
  let {
    theme
  } = _ref4;
  return css(["color:", ";"], theme.palettes.brand.primary);
};
export const itemContent = _ref5 => {
  let {
    theme
  } = _ref5;
  return css(["", " ", " background:", ";border-radius:6px;color:", ";"], getTypography(theme, TypographyName.BODY), getSpacing.padding(theme, SpacingName.SMALL), theme.palettes.neutrals.lightest, theme.palettes.neutrals.darkest);
};
//# sourceMappingURL=Accordion.style.js.map